const APP_ROUTES_CONSTANT = {
	onboarding: {
		upgrade: '/onboarding/upgrade-screen',
	},
	postpaid: {
		home: '/postpaid/home',
		cashback: '/postpaid/cashback',
	},
	faqs: {
		faq: '/faq',
		detailed: '/detailed-faq',
	},

	somethingWrong: '/something-went-wrong',
};
export default APP_ROUTES_CONSTANT;
